import { type CreateClientConfig } from "@hey-api/client-fetch";
import { isValid, parseISO } from "date-fns";

const isoPattern =
  /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?([Zz]|[+-]\d{2}:?\d{2})?)?$/;

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  responseTransformer: async (response: unknown) => {
    const deserializeDates = (value: unknown): unknown => {
      if (
        value === null ||
        value === undefined ||
        (typeof value !== "object" && typeof value !== "string")
      ) {
        return value;
      }
      if (typeof value === "string" && isoPattern.test(value)) {
        const parsed = parseISO(value);
        if (isValid(parsed)) {
          return parsed;
        }
      }
      if (Array.isArray(value)) {
        value.forEach((item, i) => {
          (value as unknown[])[i] = deserializeDates(item);
        });
        return value;
      }
      if (typeof value === "object") {
        const record = value as Record<string, unknown>;
        for (const key of Object.keys(record)) {
          record[key] = deserializeDates(record[key]);
        }
        return record;
      }
      return value;
    };
    return deserializeDates(response);
  },
});
